<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
@import './css/bootstrap.css';
@import './css/borakatsu-common.css';
@import './css/borakatsu-light.css';
@import './css/borakatsu-textsize.css';
@import './css/borakatsu-toggle.css';
@import './css/all.min.css';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
